import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from "rxjs";
import {Chapter} from "it/primatoo/openapi/api/org/schemas/common/docs/_listtemplatechapterresponse/Chapter";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {NgrxWidgetSelectors} from '../store';
import {ChapterStatus} from "it/primatoo/openapi/api/org/schemas/common/docs/ChapterStatus";

@UntilDestroy()
@Component({
  selector: 'pt-widget-disabled',
  template: `
    <!--    ngbTooltip="Per modificare imposta lo stato su 'In lavorazione'" container="body"-->
    <div class='full-space' #widgetDisabled>
      <div *ngIf='showLoader' class='spinner-border text-secondary spinner-border-sm'>
      </div>

      <div *ngIf="invalidStatus"
        class="wrapper"
        (mouseenter)="enter()"
        (mousemove)="move($event)"
        (mouseleave)="leave()">
        <div class="movingTooltip" [ngClass]="mouseMove ? 'onMove' : 'notMove'">
          Per modificare imposta lo stato su 'In lavorazione'
        </div>
      </div>

    </div>
  `,
  styles: [`

    .mouse-circle {
      position: absolute;
      border: solid 1px #ccc;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: white;
    }

    .show {
      opacity: 1 !important;
    }

    .sites-circle {
      z-index: 500;

      position: absolute;
      border: solid 1px #ccc;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: blue;
      pointer-events: none;
      transition-duration: 200ms;
      transition-timing-function: ease-out;
      transform: translate(-50%, -50%);
      opacity: 0;
    }

    .wrapper {
      position: relative;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .full-space {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 100%;
      height: calc(100% - 30px);
      top: 30px;
      z-index: 1000;
      border: 30px;
      left: 0;
      opacity: 0;
      /*background: blue;*/
      cursor: not-allowed;
    }`]
})
export class WidgetDisabledComponent {
  @ViewChild('widgetDisabled', {static: true}) widgetDisabled: ElementRef;
  @Input() showLoader: boolean;

  activeChapter$: Observable<Chapter> = this.store.select(NgrxWidgetSelectors.getActiveChapterInfo);

  mouseMove = false;
  invalidStatus = false;

  constructor(
    private store: Store,
    private el: ElementRef
  ) {
    this.activeChapter$.pipe(
      untilDestroyed(this)
    ).subscribe((chapter: Chapter) => {
      const validStatus = !chapter?.currentStatus || chapter?.currentStatus === ChapterStatus.WORKING;
      this.invalidStatus = !validStatus;
    });

  }

  get tooltip() {
    return this.widgetDisabled.nativeElement.querySelector('.movingTooltip');
  }

  enter() {
    this.tooltip.classList.add('show');
  }

  move(e: { pageX: number; pageY: number }) {
    this.mouseMove = true;
    // const tooltipStyle = this.tooltip.style;
    // const offsetLeft = this.widgetDisabled.nativeElement.offsetLeft;
    // const offsetTop = this.widgetDisabled.nativeElement.offsetTop;
    // tooltipStyle.left = (e.pageX - 50 - offsetLeft) + 'px';
    // tooltipStyle.top = (e.pageY + 25 - offsetTop) + 'px';
  }

  leave() {
    this.tooltip.classList.remove('show');
  }
}
